<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h1>Connectez-vous</h1>

        <div class="alert alert-danger" role="alert" v-bind:class="{ hide: status.login.errorMessage == null }">
          {{status.login.errorMessage}}
        </div>

        <form @submit.prevent="login">
          <div class="control-group">
            <div class="form-group floating-label-form-group controls mb-0 pb-2">
              <label>Email</label>
              <input type="text" class="form-control" v-model="loginForm.email" placeholder="Email" />
            </div>
          </div>

          <div class="control-group">
            <div class="form-group floating-label-form-group controls mb-0 pb-2">
              <label>Mot de passe</label>
              <input
                type="password"
                class="form-control"
                v-model="loginForm.password"
                placeholder="Mot de passe"
              />
            </div>
          </div>

          <div class="control-group">
            <div>
              <router-link :to="{name: 'UserForget'}">
                Mot de passe oublié
              </router-link>
            </div>
          </div>

          <br />
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-xl" v-bind:class="{ hide: status.login.loading == true }">Connexion</button>
            
            <div class="spinner-border text-primary" role="status" v-bind:class="{ hide: status.login.loading == false }">
              <span class="sr-only">Connexion...</span>
            </div>
            <!-- <button type="button" class="btn btn-primary mb-2" @click="checkToken()">Check Token</button> -->
          </div>
        </form>
      </div>

      <div class="col-md-6">
        <h1>Inscrivez-vous</h1>

        <div class="alert alert-danger" role="alert" v-bind:class="{ hide: status.register.errorMessage == null }">
          {{status.register.errorMessage}}
        </div>

        <form @submit.prevent="register">
          <div class="control-group">
            <div class="form-group floating-label-form-group controls mb-0 pb-2">
              <label>Prénom</label>
              <input
                type="text"
                class="form-control"
                v-model="registerForm.firstname"
                placeholder="Prénom"
              />
            </div>
          </div>

          <div class="control-group">
            <div class="form-group floating-label-form-group controls mb-0 pb-2">
              <label>Nom de famille</label>
              <input
                type="text"
                class="form-control"
                v-model="registerForm.lastname"
                placeholder="Nom de famille"
              />
            </div>
          </div>

          <div class="control-group">
            <div class="form-group floating-label-form-group controls mb-0 pb-2">
              <label>Email</label>
              <input
                type="text"
                class="form-control"
                v-model="registerForm.email"
                placeholder="Email"
              />
            </div>
          </div>

          <div class="control-group">
            <div class="form-group floating-label-form-group controls mb-0 pb-2">
              <label>Mot de passe</label>
              <input
                type="password"
                class="form-control"
                v-model="registerForm.password"
                placeholder="Mot de passe"
              />
            </div>
          </div>

          <div class="control-group control-group-switch">
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="customSwitch1"
                v-model="registerForm.newsletterActivated"
              />
              <label class="custom-control-label" for="customSwitch1">Recevoir la newsletter</label>
            </div>
          </div>

          <br />
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-xl" v-bind:class="{ hide: status.register.loading == true }">Inscription</button>

            <div class="spinner-border text-primary" role="status" v-bind:class="{ hide: status.register.loading == false }">
              <span class="sr-only">Inscription...</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "UserLogin",
  getterMethods: null,
  props: ["redirect"],
  data() {
    return {
      loginForm: { email: "", password: "" },
      registerForm: { firstname: "", lastname: "", email: "", password: "", newsletterActivated: false },
      errorLogin: {},
      status: {
        login: { loading: false, errorMessage: null },
        register: { loading: false, errorMessage: null }
      }
    };
  },
  mounted() {
    this.getterMethods = mapGetters(["getUserToken"]);
    console.log("userToken : ");
    // console.log(this.$store);
    console.log(this.$store.getters.getUserToken);
    console.log("route redirect : " + this.$route.params.redirect);
    console.log(this.$route.query.redirect);

    // console.log(this.getterMethods);
    // console.log(this.getterMethods.getUserToken());
    // console.log(this.getterMethods.getUserToken());
    // console.log(this.getterMethods["user/getUserToken"]());
  },
  methods: {
    checkToken: function() {
      // var userToken = mapGetters(["getUserToken"]);
      console.log("userToken : ");
      console.log(this.$store.getters.getUserToken);

      // console.log(this.getterMethods);
      // console.log(this.getterMethods.getUserToken());
    },
    login: function() {
      var vm = this;
      console.log(this.loginForm);
      vm.status.login.loading = true;
      vm.status.login.errorMessage = null;

      axios
        .post(process.env.BACKEND_URL + "/api/users/token", vm.loginForm)
        .then(response => {
          console.log(response);

          if (response.status == 200) {
            vm.$store.dispatch("logUser", response.data.token);

            if (vm.$route.query.redirect)
              vm.$router.push(vm.$route.query.redirect);
            else 
              vm.$router.push("/search");
          }

          vm.status.login.loading = false;
        }).catch(error => {
          if(error.response){
            if(error.response.status == 404)
              vm.status.login.errorMessage = "Utilisateur ou mot de passe incorrect";
            else if(error.response.status == 500)
              vm.status.login.errorMessage = "Erreur serveur : <br /><i>" + JSON.stringify(error.response.data) + "</i>";
          } else
            vm.status.login.errorMessage = "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.login.loading = false;
        });

      return false;
    },
    register: function() {
      var vm = this;
      vm.status.register.loading = true;
      vm.status.register.errorMessage = null;

      axios
        .post(process.env.BACKEND_URL + "/api/users/register", vm.registerForm)
        .then(response => {
          console.log(response);

          if (response.status == 200) {
            vm.loginForm.email = vm.registerForm.email;
            vm.loginForm.password = vm.registerForm.password;

            vm.login();
          }else{
            vm.status.register.errorMessage = "Erreur non prise en charge";
          }

          vm.status.register.loading = false;
        }).catch(error => {
          console.log(error.response);
          if(error.response){
            if(error.response.status == 409)
              vm.status.register.errorMessage = "Utilisateur déjà existant";
            if (error.response.status == 411)
              vm.status.register.errorMessage =
                "Le mot de passe doit comporter au minimum 6 caractères et au moins 2 des critères suivants : une lettre minuscule, une lettre majuscule, un chiffre, un caractère spéciale";
            else if(error.response.status == 500)
              vm.status.register.errorMessage = "Erreur serveur : <br /><i>" + JSON.stringify(error.response.data) + "</i>";
          } else
            vm.status.register.errorMessage = "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.register.loading = false;
        });

      return false;
    }
  }
};
</script>

<style scope>
.container {
  padding-top: 40px;
}

a.search-list-item {
  display: block;
  text-decoration: none;
  color: black;
}

</style>



// WEBPACK FOOTER //
// src/components/users/UserLogin.vue